<template>
  <div style="min-height:100vh;background-color:rgba(248,249,250);display:flex;flex-direction:column">
    <nav v-if="router.currentRoute.value.name != 'login' && router.currentRoute.value.name != 'resetPassword'"
      class="navbar navbar-expand-lg navbar-light bg-white border-bottom">
      <div class="container-fluid">
        <a class="navbar-brand" @click="router.push('/')" style="cursor:pointer">
          <img src="./assets/logo2.png" style="width:200px">
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain"
          aria-controls="navbarMain" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarMain">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0" style="margin-left:auto">
            <li class="nav-item">
              <router-link to="/" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/agent" class="nav-link">Area Agente</router-link>
            </li>
            <li class="nav-item" v-if="user.loggedRole >= 2">
              <router-link to="/admin" class="nav-link">Configurazione</router-link>
            </li>
          </ul>

          <div class="d-flex align-items-center" style="justify-content: center">
            <span class="navbar-text me-2">
              {{ user.loggedUsername }}
            </span>
            <span v-if="user.logged" @click="logout" class="text-decoration-underline text-primary"
              style="cursor:pointer">Logout
            </span>
          </div>
        </div>
      </div>
    </nav>
    <router-view @alert="handleAlert" />
    <footer class="bg-body-tertiary text-center text-lg-start" style="margin-top:auto">
      <!-- Copyright -->
      <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.05);">
        Powered By
        <a class="text-body" target="_blank" href="https://startappitalia.it">Startapp srl</a>
      </div>
      <!-- Copyright -->
    </footer>
  </div>
  <div id="" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    ref="modalLog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow p-3 mb-5">
        <div class="modal-header">
          E' necessario rieffettuare il login
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div data-mdb-input-init class="form-outline form-white mb-4">
              <input type="text" id="typeEmailX" class="form-control form-control-lg" v-model="username" />
              <label class="form-label" for="typeEmailX">Username</label>
            </div>

            <div data-mdb-input-init class="form-outline form-white mb-4">
              <input type="password" id="typePasswordX" class="form-control form-control-lg" v-model="password" />
              <label class="form-label" for="typePasswordX">Password</label>
            </div>

            <p class="small mb-5 pb-lg-2"><a class="text-white-50" style="cursor:pointer"
                @click="router.push('resetPassword')">Password Dimenticata?</a></p>
            <button data-mdb-button-init data-mdb-ripple-init class="btn btn-outline-dark btn-lg px-5" type="button"
              @click="relogin()">Login</button>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 9999">
    <div class="toast" role="alert" aria-live="assertive" aria-atomic="true" ref="toastAlert" data-bs-dismiss="toast"
      data-bs-autohide="true">
      <div class="toast-header">
        <svg class="bd-placeholder-img rounded me-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
          <rect width="100%" height="100%" :fill="alertMessage.color"></rect>
        </svg>
        <strong class="me-auto">Alert</strong>
        <small style="cursor:pointer" data-bs-dismiss="toast">Close</small>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
      <div class="toast-body">
        {{ alertMessage.message }}
      </div>
    </div>
  </div>
</template>
<script>
import { useUserStore } from '@/stores/userStore.js';
import { onMounted, ref } from 'vue'
import { Modal, Toast } from 'bootstrap'
import loginMethods from './api/resources/loginMethods'
import router from './router/index'
import usersMethods from './api/resources/usersMethods';
export default {

  setup() {
    const modalLog = ref(null);
    const toastAlert = ref(null);
    var modLog = Modal;
    var tosAlert = Toast;
    var user = useUserStore();
    const originalFetch = window.fetch;
    const username = ref("");
    const password = ref("");
    let loginPromiseResolve = null; // Stores resolve function for the login promise
    let loginPromiseReject = null; // Stores reject function for the login promise
    let toLogin = true;
    const alertMessage = ref({
      message: "test",
      color: "red"
    });

    window.fetch = async (...args) => {
      try {
        //salvo la risposta originale
        const response = await originalFetch(...args);
        //creo una copia della risposta da utilizzare per l'eventuale chiamata di relogin
        const clonedResponse = response.clone();

        const handleResponse = async (data) => {
          for (const message of data.messages || []) {
            if (message.message && message.message.includes("relogin")) {
              // nel messaggio di risposta è indicato relogin, quindi il refresh_token è valido ma scaduto
              user.logout();
              console.log("Attempting relogin...");
              modLog.show();

              // triggero la promise che apre il modal e aspetta l'input
              await promptLogin();
              console.log("Relogged in successfully");
              toLogin = false;
              modLog.hide();
              toLogin = true;
              // se il login è corretto rieffettuo una fetch e ritorno il risultato
              return await fetch(...args);
            }
          }
          // in questo caso il refresh_token non è scaduto, ritorno la risposta originale
          return response;
        };

        try {
          const data = await clonedResponse.json();
          //ritorno il risultato di handleResponse se non ci sono errori
          return await handleResponse(data);
        } catch (err) {
          console.warn("Response is not JSON or failed to parse", err);
          return response; // Errore nel parsing json
        }
      } catch (error) {
        console.error("Fetch error:", error);
        //user.logout();
        throw error; // Errore nella fetch originale
      }
    };


onMounted(() => {
  modLog = new Modal(modalLog.value);
  modalLog.value.addEventListener("hide.bs.modal", handleModalHide);
  tosAlert = new Toast(toastAlert.value);

  const isAppleDevice = () => {
    // Define the variables your logic needs
    const ua = navigator.userAgent;
    const platform = navigator.platform;
    const touchPoints = navigator.maxTouchPoints || 0;

    // 1. Standard mobile (iPhone/iPod)
    const isIPhone = /iPhone|iPod/.test(ua);

    // 2. iPad (Modern iPads report as MacIntel but have touch)
    const isIPad = /iPad/.test(ua) || (platform === 'MacIntel' && touchPoints > 1);

    // 3. macOS (Desktop/Laptop)
    const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(ua) && touchPoints <= 1;

    // Return true if any of these are true
    return isIPhone || isIPad || isMac;
  };

  // Now use the result
  if (isAppleDevice()) {
    user.isApple = true; // Using your variable name
    //console.log("Device OS: Apple Ecosystem detected");
  } else {
    user.isApple = false;
    //console.log("Device OS: Non-Apple");
  }
});

    function handleModalHide() {
      if (toLogin) {
        router.push("/login")
      }
    }
    const handleAlert = (obj) => {
      alertMessage.value.message = obj.message;
      alertMessage.value.color = obj.color;
      tosAlert.show();
    }

    async function promptLogin() {
      return new Promise((resolve, reject) => {
        loginPromiseResolve = resolve;
        loginPromiseReject = reject;
      })
    }

    async function relogin() {
      if (await loginMethods.login({ username: username.value, password: password.value })) {
        if (loginPromiseResolve) {
          handleAlert({ message: "Login effettuato!", color: "green" })
          loginPromiseResolve();
        }
      }
      else {
        if (!loginPromiseReject) {
          handleAlert({ message: "Logout!", color: "red" })
          loginPromiseReject(new Error('Login canceled by user'));
        }
      }
    }

    function logout() {
      user.logout();
      handleAlert({ message: "Logout effettuato!", color: "green" })
      router.push("login")
    }

    return {
      modalLog, username, password, relogin, router, user, logout,
      alertMessage, toastAlert, handleAlert
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
